<template>
  <el-col :span="item.config.span" :class="{ 'none-display': !getItemLabel }">
    <el-form-item
      class="project_item"
      :label-width="item.config.labelWidth ? `${item.config.labelWidth}px` : null"
      :prop="item.vModel"
    >
      <template #label>
        <div class="flex-column" style="width: 100%">
          <div class="label_box">
            <span v-if="item.config.required" class="required_icon"></span>
            <div>
              <div v-html="getItemLabel" style="width: 100%" />
            </div>
          </div>
          <span v-if="item.config.description" :class="['desc_text', { 'pl-10': item.config.required }]">
            {{ item.config.description || '问题描述' }}
          </span>
        </div>
      </template>
      <!--特殊处理组件 二次包装的组件-->
      <template v-if="componentList.includes(item.typeId)">
        <component
          :is="getComponentName(item)"
          v-model="dataModel"
          :item="item"
          :models="models"
          :pageShowMore="pageShowMore"
        />
      </template>
      <template v-else-if="['RADIO', 'CHECKBOX', 'NPS'].includes(item.typeId)">
        <component
          :is="getComponentName(item)"
          v-model="dataModel"
          :item="item"
          :models.sync="models"
          @other-input-change="otherInputChange"
        />
      </template>
      <!--  OCR组件-->
      <template v-else-if="['OCR'].includes(item.typeId)">
        <component
          :is="getComponentName(item)"
          v-model="dataModel"
          :item="item"
          :models="models"
          @ocr-success="
            (val) => {
              $emit('ocr-success', val)
            }
          "
        />
      </template>
      <!--       分页-->
      <template v-else-if="['PAGINATION'].includes(item.typeId)">
        <component
          :is="getComponentName(item)"
          v-bind="{ ...item }"
          @next="
            (page) => {
              $emit('next', page)
            }
          "
          @prev="
            (page) => {
              $emit('prev', page)
            }
          "
        />
      </template>
      <template v-else>
        <!--    其他无特殊处理组件-->
        <component :is="getComponentName(item)" :item="item" v-model="dataModel" v-bind="{ ...item }" />
      </template>
    </el-form-item>
    <!--      一页一题 -->
    <template v-if="!pageShowMore && item.currPageNum < item.totalPageNum">
      <div class="flex-center">
        <el-button
          :style="getSubmitBtnStyle"
          type="primary"
          class="submit-btn-form-item btn-fixed"
          @click="
            () => {
              $emit('next', item.currPageNum)
            }
          "
          >下一题</el-button
        >
      </div>
    </template>
  </el-col>
</template>

<script>
import { handleChangeLabel } from './FormItemLabel'
import { isMobile } from '@/utils'

export default {
  name: 'GenerateFormItem',
  props: ['item', 'models', 'rules', 'index', 'seqNo', 'pageShowMore', 'btnStyle'],
  data() {
    return {
      componentList: [
        'SELECT',
        'IMAGE_CAROUSEL',
        'IMAGE_UPLOAD',
        'UPLOAD',
        'CASCADER',
        'IMAGE_SELECT',
        'INPUT',
        'DATE',
        'SUB_FORM',
        'RATE',
        'SLIDER',
        'NUMBER',
        'FUNCTION_CALC'
      ],
      config: this.item.config,
      dataModel: this.models[this.item.vModel]
    }
  },
  computed: {
    getItemLabel() {
      let sep = ''
      if (this.seqNo) {
        sep = `<span style="white-space: nowrap; width: fit-content">${this.seqNo}.&nbsp</span>`
      }
      // 不展示标题就展示序号
      if (!this.item.config.showLabel) {
        return sep
      }
      let content = this.item.config.label
      if (this.item.config.label.startsWith('<p>')) {
        return content.slice(0, 3) + sep + content.slice(3)
      }
      return sep + content
    },
    getSubmitBtnStyle() {
      const { btnStyle } = this
      if (!btnStyle) return ''
      let style = {}
      if (btnStyle.answerPageSubButtonColor)
        style['background-color'] = `${btnStyle.answerPageSubButtonColor} !important`
      if (btnStyle.answerPageSubTextColor) style['color'] = btnStyle.answerPageSubTextColor
      return style
    }
  },
  watch: {
    dataModel: {
      deep: true,
      handler(val) {
        this.models[this.item.vModel] = val
        handleChangeLabel(this.models, this.item, val)
        this.$emit('update:models', {
          ...this.models,
          [this.item.vModel]: val
        })
        this.$emit('input-change', val, this.item.vModel, this.item)
      }
    },
    models: {
      deep: true,
      handler(val) {
        this.dataModel = val[this.item.vModel]
      }
    }
  },
  methods: {
    // RADIO CHECKBOX 其他输入框输入
    otherInputChange(value, item) {
      handleChangeLabel(this.models, item, value)
      this.$emit('update:models', {
        ...this.models
      })
    },
    getComponentName(item) {
      // 是否是移动端环境
      if (isMobile() && item.config.mobileTag) {
        return item.config.mobileTag
      }
      return item.config.tag
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';

// .none-display {
//   ::v-deep .el-form-item__label {
//     display: none !important;
//   }
// }
::v-deep {
  .el-form-item__label {
    width: 100% !important;
    display: flex;
    align-items: center;
    padding: 0 0 10px;
    line-height: normal;
  }
  .el-form-item__label p {
    word-break: break-all;
    line-height: normal;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: '';
  }
  // .project_item,
  // .el-form-item__content,
  // .el-input,
  // .el-checkbox__label,
  // .el-radio__label {
  //   font-size: 16px;
  // }

  .el-form-item__label,
  .el-form-item__content,
  .el-input,
  .el-checkbox__label,
  .el-radio__label,
  .el-cascader-panel {
    font-size: 16px;
  }
}
.desc_text {
  color: #938d8d;
  font-size: 16px;
  line-height: 1;
  font-weight: 400;
  display: inline-block;
  width: 100%;
  word-break: break-all;
}
.required_icon {
  margin-right: 4px;
  &::before {
    content: '*';
    color: #f56c6c;
  }
}
.label_box {
  display: flex;
  align-items: baseline;
  font-size: 16px;
}
</style>
